import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';

export const ALLOWED_INVITES_AND_PAPER_COUNTRY_CODES = [
  CountryCodes.GB,
  CountryCodes.US,
  CountryCodes.CA,
  CountryCodes.ZA,
  CountryCodes.AU,
];
